<template>
  <ContentDisplay class="barriers" :blocks-length="1">
    <template #content-block-1>
      <HeadingDisplay
        class="barriers__title"
        title="Monitoramento de Barreiras"
        size="extra-small"
      />
      <TableDisplay
        :columns="monitoringBarriersColumns"
        :data="customOperationData.monitoring"
      />
    </template>
  </ContentDisplay>
</template>

<script lang="ts" setup>
import {
  ContentDisplay,
  TableDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import {
  CustomOperation,
  MonitoringBarrier
} from '@/modules/trade/services/custom-operations';

interface Props {
  customOperationData: CustomOperation;
}
defineProps<Props>();

const monitoringBarriersColumns = [
  {
    getter: 'type',
    header: 'Tipo'
  },
  {
    getter: (monitoringBarrier: MonitoringBarrier) => {
      return monitoringBarrier.level.formatted;
    },
    header: 'Nível',
    align: 'right'
  },
  {
    getter: (monitoringBarrier: MonitoringBarrier) => {
      return monitoringBarrier.distance.formatted;
    },
    header: 'Distância',
    align: 'right'
  }
];
</script>

<style lang="less" scoped>
.barriers {
  ::v-deep .content-display__blocks {
    margin-top: @size-spacing-x800;
    margin-bottom: @size-spacing-x800;
  }

  &__title {
    margin-bottom: @size-spacing-x500;
  }
}
</style>
